module.exports = __webpack_public_path__ + "static/media/mainTopicMobile.e5250dce.svg";